import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useFormikContext } from "formik"
import {
  getListRegionalAll,
  getListSubRegionalByRole,
  resetUrlResponse,
  uploadAction
} from "../../../../../redux/actions/MasterDataAction.jsx"
import { getUserRegional } from "../../../../service/userManagementAction.js"
import { UPLOAD } from "../../../../../constants/InitTypeConstants.js"
import { UploadIcon } from "../../../../../component/atoms/Icons/SVG/upload.jsx"
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle, FieldFeedbackLabel
} from "../../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import {
  AddressMolecule,
  PopUpMapSelector,
  SelectInput,
  TextInput,
  UploadComponent
} from "../../../../../component/index.jsx"
import { handleSpace } from "../../../../helpers/TextHelper.js"
import { useTranslation } from "react-i18next"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers/index.js"
import { ICON_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { capitalize } from "@material-ui/core/utils"
import { BaseMapSelector } from "../../../../../component/atoms/MapSelector/BaseMapSelector.jsx"
import { Marker } from "@react-google-maps/api"

export const DataMitraSwasta = ({ mitraTypeEdit, isReadOnly, mitraType, changeType }) => {
  const { MasterData } = useSelector((state) => state)
  const dispatch = useDispatch()
  const [avatar, setAvatar] = useState("")
  const {
    values: formValues,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    errors,
    touched
  } = useFormikContext()
  const { t } = useTranslation()
  const [urlKtp, setUrlKtp] = useState("")
  const userLogin = JSON.parse(localStorage.getItem("userLogin"))
  const [subRegionalList, setSubRegionalList] = useState([])
  const [subRegionalId, setSubRegionalId] = useState(null)
  const [enableSubRegional, setEnableSubRegional] = useState(false)
  const [regionalList, setRegionalList] = useState([])
  const [regionalId, setRegionalId] = useState(null)
  const [isHaveRegional, setIsHaveRegional] = useState(false)
  const [isChangeRegional, setIsChangeRegional] = useState(false)
  const [showMapSelector, setShowMapSelector] = useState(false)

  // Sync regional/subRegional from formValues when editing existing mitra
  useEffect(() => {
    if (formValues["regionalId"] && !regionalId) {
      setRegionalId(formValues["regionalId"])
    }
    if (formValues["sub_regional_id"] && !subRegionalId) {
      setSubRegionalId(formValues["sub_regional_id"])
    }
  }, [formValues["regionalId"], formValues["sub_regional_id"]])

  const handleMapSave = ({ lat, lng }) => {
    setFieldValue("latitude", lat)
    setFieldValue("longitude", lng)
    setFieldTouched("latitude", true)
    setFieldTouched("longitude", true)
    setTimeout(() => {
      setFieldError("latitude", undefined)
      setFieldError("longitude", undefined)
    }, 0)
    if (window.google?.maps?.Geocoder) {
      const geocoder = new window.google.maps.Geocoder()
      geocoder.geocode({ location: { lat, lng }, language: "id" }, (results, status) => {
        if (status === "OK" && results?.[0]) {
          setFieldValue("mitraAddress", results[0].formatted_address)
        }
      })
    }
    setShowMapSelector(false)
  }

  useEffect(() => {
    const userRegional = getUserRegional()
    if (userRegional !== "null") {
      setFieldValue("regionalId", userRegional)
      setRegionalId(userRegional)
      setIsHaveRegional(true)
    }
  }, [regionalList])

  useEffect(() => {
    dispatch(getListRegionalAll())
  }, [dispatch])

  useEffect(() => {
    if ((formValues["regionalId"] && formValues["regionalId"].trim() !== "") ||
      (regionalId && regionalId.trim() !== "")) {
      dispatch(getListSubRegionalByRole(formValues["regionalId"] || regionalId, userLogin?.role));
      setEnableSubRegional(true)
    } else {
      setEnableSubRegional(false)
    }
  }, [formValues["regional_id"], regionalId])

  useEffect(() => {
    if (MasterData.listRegionalAll != undefined) {
      setRegionalList(
        MasterData.listRegionalAll.map((value) => ({
          label: value.name + " (" + value.code + ")",
          value: value.id
        }))
      )
    }
  }, [MasterData.listRegionalAll])

  useEffect(() => {
    if (MasterData.listSubRegionalByRole) {
      setSubRegionalId(formValues["sub_regional_id"] || "")
      setSubRegionalList(
        MasterData.listSubRegionalByRole.map((value) => ({
          label: value.name,
          value: value.id
        }))
      )
    }
  }, [MasterData.listSubRegionalByRole])

  function onChangeRegional(e) {
    setRegionalId(e)
    setIsChangeRegional(true)
    setSubRegionalId("")
  }

  function onChangeAvatar(e) {
    dispatch(uploadAction({ data: e, type: UPLOAD.AVATAR }))
  }

  function onChangeFileKtp(e) {
    dispatch(uploadAction({ data: e, type: UPLOAD.KTP }))
  }

  useEffect(() => {
    if (formValues["mitra_type"]) {
      changeType(formValues)
    }
  }, [formValues])

  useEffect(() => {
    if (MasterData.urlResponseUpload) {
      if (MasterData.uploadType === UPLOAD.AVATAR) {
        setAvatar(MasterData.urlResponseUpload)
      }
    }
    if (MasterData.urlResponseUpload) {
      if (MasterData.uploadType === UPLOAD.KTP) {
        setUrlKtp(MasterData.urlResponseUpload)
      }
    }
    return () => {
      dispatch(resetUrlResponse())
    }
  }, [MasterData.urlResponseUpload])

  const placeholder = <UploadIcon />

  return (
    <>
      <Card className="card-custom card-shadowless">
        <CardBody>
          <RowModule>
            <CardHeaderTitle className={"my-12"}>
              {t("card_title_mitra_list").toUpperCase()}
            </CardHeaderTitle>
          </RowModule>
          <RowModule>
            <SelectInput
              required={true}
              name="mitra_type"
              editable={!mitraTypeEdit}
              label={t("label_select_mitra_type")}
              placeholder={t("placeholder_choose_one")}
              options={mitraType}
              withoutFeedback={true}
              clearNow={true}
              value={formValues["mitra_type"]}
            />
          </RowModule>
          <RowModule>
            <SelectInput
              name="regionalId"
              required
              onChange={onChangeRegional}
              editable={isHaveRegional ? false : true}
              label={"Regional"}
              placeholder={t("placeholder_choose_one")}
              value={regionalId}
              options={regionalList}
            />
          </RowModule>
          <RowModule>
            <SelectInput
              name="sub_regional_id"
              required
              onChange={(e) => setSubRegionalId(e)}
              editable={enableSubRegional}
              label={t("label_sub_regional")}
              placeholder={t("label_choose_one")}
              value={subRegionalId}
              options={subRegionalList}
            />
          </RowModule>
          <RowModule>
            <UploadComponent
              urlParsing={avatar}
              required={true}
              name="mitra_pic_url"
              label={t("label_photo_profile")}
              editable={!isReadOnly}
              onChange={onChangeAvatar}
              placeholder={placeholder}
              maxSize={2048000}
              maxSizeText="2 MB"
            />
          </RowModule>
          <RowModule>
            <TextInput
              required={true}
              editable={!isReadOnly}
              label={t("label_company_name")}
              name="name"
              placeholder={t("placeholder_input_company_name")}
              onKeyDown={handleSpace}
            />
          </RowModule>
          <RowModule>
            <TextInput
              required={true}
              editable={!isReadOnly}
              label="Email"
              name="email"
              placeholder="Input email"
            />
          </RowModule>
          <RowModule>
            <TextInput
              required={true}
              editable={!isReadOnly}
              type="text"
              label={t("label_telp_number")}
              name="phone"
              placeholder={t("placeholder_input_telephone_number")}
            />
          </RowModule>
        </CardBody>
      </Card>
      <Card className={"card-custom card-shadowless"}>
        <CardHeader title={t("label_person_in_charge").toUpperCase()} />
        <CardBody>
          <RowModule>
            <TextInput
              required={true}
              editable={!isReadOnly}
              label={t("label_name_as_per_id")}
              name="coordinator"
              placeholder={t("placeholder_input_organization_name")}
              onKeyDown={handleSpace}
            />
          </RowModule>
          <RowModule>
            <TextInput
              editable={!isReadOnly}
              required={true}
              label={t("label_ktp_number")}
              type="text"
              name="ktp_no"
              placeholder={t("placeholder_input_ktp_number")}
            />
          </RowModule>
          <RowModule>
            <UploadComponent
              urlParsing={urlKtp}
              name="ktp_pic_url"
              required={true}
              label={t("label_ktp_picture")}
              editable={!isReadOnly}
              onChange={onChangeFileKtp}
              placeholder={placeholder}
              maxSize={2048000}
              maxSizeText="2 MB"
            />
          </RowModule>
        </CardBody>
      </Card>
      <RowModule>
        <CardHeaderTitle className={"my-8 ml-8"}>
          {t("label_organization_address").toUpperCase()}
        </CardHeaderTitle>
      </RowModule>
      <RowModule>
        <label className={"ml-8"}>
          {capitalize(t("map_pin_location"))} <span className={"text-danger"}>*</span>
        </label>
      </RowModule>
      <RowModule>
        <div
          className={"mx-8 position-relative cursor-pointer"}
          onClick={() => !isReadOnly && setShowMapSelector(true)}>
          {/* Overlay add icon when no location set yet */}
          {!(formValues?.latitude && formValues?.longitude) && (
            <div
              className={
                "position-absolute d-flex justify-content-center align-items-center zindex-3"
              }
              style={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
              <SVG src={toAbsoluteUrl(ICON_CONSTANTS.QUICK_ACTION_ADD)} />
            </div>
          )}
          <div
            className={
              (touched.latitude || touched.longitude) && (errors.latitude || errors.longitude)
                ? "border border-danger rounded-lg"
                : ""
            }>
            <BaseMapSelector
              className={"rounded-lg mb-2"}
              id={"preview-individual-map-selector"}
              latitude={formValues?.latitude}
              longitude={formValues?.longitude}
              isSelector={false}
              editable={false}
              customMarkers={() =>
                formValues?.latitude && formValues?.longitude ? (
                  <Marker
                    position={{
                      lat: parseFloat(formValues.latitude),
                      lng: parseFloat(formValues.longitude)
                    }}
                    icon={toAbsoluteUrl(ICON_CONSTANTS.MARKER_MITRA)}
                    draggable={false}
                  />
                ) : null
              }
              customContainerStyle={{ height: "250px" }}
              options={{ zoomControl: false }}
              zoom={15}
            />
          </div>
          <FieldFeedbackLabel
            error={errors?.latitude || errors?.longitude}
            touched={touched.latitude && touched.longitude}
            label={t("label_base_location_on_map")}
          />
        </div>
      </RowModule>
      <AddressMolecule
        required={true}
        name={"mitra"}
        isReadOnly={isReadOnly}
        addressTitle={t("label_company_address").toUpperCase()}
        regionalId={regionalId}
        byRegional={true}
        isChangeRegional={isChangeRegional}
      />
      <PopUpMapSelector
        show={showMapSelector}
        onCancel={() => setShowMapSelector(false)}
        onSave={handleMapSave}
        initialLat={formValues?.latitude}
        initialLng={formValues?.longitude}
        hasLocationAlreadySaved={!!(formValues?.latitude && formValues?.longitude)}
        icon={ICON_CONSTANTS.MARKER_MITRA}
      />
    </>
  )
}
